import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
export var add = mutatorAction('addToPendingFavoritesMap', function addToPendingFavoritesMap(key) {
    getStore().isFavoritingInProgress.set(key, true);
});
export var remove = mutatorAction('removeFromPendingFavoritesMap', function removeFromPendingFavoritesMap(key) {
    getStore().isFavoritingInProgress.delete(key);
});
//# sourceMappingURL=pendingFavoritesMapMutators.js.map